import axios, { decodeVinUrl, CancelToken } from 'apis';
import { sessionService } from 'redux-react-session';
import { getThunkActionCreator } from 'redux-thunk-routine';
import {  } from 'actions';
import { 
  getVehiclesRoutine,
  getUnstoredVehiclesRoutine,
  getVehicleRoutine, 
  createVehicleRoutine,
  updateVehicleRoutine, 
  storeVehicleRoutine,
  takeOutVehicleRoutine,
  releaseVehicleRoutine, 
  clearLocalVehiclesRoutine,
  clearLocalUnstoredVehiclesRoutine,
  clearLocalActiveVehicleRoutine,
  getFromVinVehicleInfoRoutine,
  getFromPlateVehicleInfoRoutine,
  getVehiclesStatisticsRoutine,
  clearVehiclesStatisticsRoutine
} from 'actions';

const shortAttributes = [
  'id', 
  'make',
  'model',
  'year',
  'status', 
  'created_at',
  { order: ['number'] },
  { receiver: ['id', 'receiver_type', 'name', 'address', 'phone', 'email', 'driver_license', 'license_state'] }
];
const unstoredListAttributes = [
  'id',
  'make',
  'model',
  'year',
  'status',
  'created_at',
  { order: ['number'] }
];
const plateAttributes = [
  'make',
  'model',
  'year',
  'vin',
  'color',
  'drive_type'
];

const attributes = [
  ...shortAttributes,
  'vin',
  'color',
  'drive_type',
  'license',
  'license_state',
  'storage_duration',
  'stored_at',
  'odometer',
  { order: [
    'id',
    'number',
    'status',
    'previous_status',
    'eta',
    'authorization_number',
    'created_at',
    'deadhead_miles_count',
    'en_route_miles_count',
    'towed_miles_count',
    'source',
    'scheduled_at',
    '_type',
    'impound_status',
    'received_at',
    'dispatched_at',
    'en_route_at',
    'on_scene_at',
    'towed_at',
    'completed_at',
    'police_hold',
    'class_type',
    'description',
    'internal_notes',
    'dispatcher_notes',
    'caller_name',
    'caller_phone',
    'member_first_name',
    'member_last_name',
    'member_phone',
    'authorization_number',
    'keys_availability',
    'driver_attendance',
    'insurance_company',
    'priority',
    'tow_reason',
    'service_comments',
    'equipment_type',
    'police_number',
    'police_code',
    'digital_dispatch_webhook',
    'urgently_partner_name',
    'urgently_disablement_reason',
    'urgently_callback',
    'customer_token',
    { vehicle: [
      'id',
      'status',
      'vin',
      'make',
      'model',
      'year',
      'color',
      'drive_type',
      'license',
      'license_state',
      'odometer'
    ] },
    { incident_location: ['longitude', 'latitude', 'address'] },
    { services: ['id', 'name', 'service_type'] },
    { account: ['id', 'name', 'account_type', { company: ['id', 'name'] }] },
    { user: ['id', 'first_name', 'last_name', 'phone', 'longitude', 'latitude', { trucks: ['id', 'make', 'model', 'year', 'type'] }] },
    { dispatcher: ['id', 'first_name', 'last_name'] },
    { customer_location: ['longitude', 'latitude', 'address'] },
    { recipients: ['id', 'delivery_method', 'name', 'phone', 'email'] },
    { trucks: ['id', 'make', 'model', 'year', 'type'] },
    { users: ['id', 'first_name', 'last_name', 'phone', 'longitude', 'latitude', { trucks: ['id', 'make', 'model', 'year', 'type'] }] },
    { truck: ['id', 'make', 'model', 'year'] },
    { customer: ['id', 'name', 'email', 'phone', { cards: ['id', 'brand', 'last4'] }] },
    { company_location: ['id', 'name', 'email', 'phone', 'address', 'longitude', 'latitude', { company: ['id', 'name', 'add_access_token_available'] }] },
    { destination_location: ['longitude', 'latitude', 'address'] },
    { invoice: [
      'id',
      'number', 
      'total_amount',
      'paid_amount',
      'minimum_amount', 
      'status',
      'previous_status',
      { payments: ['id', { card: ['id', 'brand', 'last4'] }, 'payer', 'payment_type', 'amount', 'created_at'] },
      { file: ['url'] },
      { expenses: [
        'id',
        { rate: ['id', { charge: ['id', 'name', 'charge_type'] }, 'value', 'basic_value_type', 'fee_value_type', {variant: ['minimum_duration', 'minimum_amount']}] },
        { default_charge: ['id', { charge: ['name', 'charge_type'] }, 'basic_rate_type'] },
        { service: ['name'] },
        'name',
        'unit_price',
        'quantity',
        'hourly_charge_duration',
        'updated_at'
      ] },
      { recipients: ['id', 'delivery_method', 'name', 'phone', 'email'] },
      'notes',
      'created_at'
    ] }
  ] }
];
const statisticsAttributes = [
  'stored_vehicles_count',
  'laid_vehicles_count',
  'released_vehicles_count',
  'over_time_vehicles_count',
  'over_time_vehicles_data',
  'stored_vehicles_invoice_amount'
];

export const getVehicles = getThunkActionCreator(
  getVehiclesRoutine,
  async ({ offset = 0, orders = { created_at: 'desc' }, query = null, statuses = ['stored', 'laid', 'for_sale'] }) => {
    getVehicles.getVehiclesCancel && getVehicles.getVehiclesCancel();
    const { token: access_token } = await sessionService.loadSession();

    return await axios.get(`/user/vehicles`,
      {
        params: { access_token, limit: 25, offset, orders, ...(query && { query }), ...(!!!query && !!statuses.length && { statuses }), attributes: shortAttributes },
        cancelToken: new CancelToken(function executor(cancel) { getVehicles.getVehiclesCancel = cancel })
      }
    );
  }
);
export const getUnstoredVehicles = getThunkActionCreator(
  getUnstoredVehiclesRoutine,
  async ({ offset = 0, orders = { created_at: 'desc' }, statuses = ['stored', 'laid', 'for_sale', 'released'] }) => {
    getUnstoredVehicles.getUnstoredVehiclesCancel && getUnstoredVehicles.getUnstoredVehiclesCancel();
    const { token: access_token } = await sessionService.loadSession();

    return await axios.get(`/user/vehicles/unstored`,
      {
        params: { access_token, limit: 25, offset, orders, ...(!!statuses.length && { statuses }), attributes: unstoredListAttributes },
        cancelToken: new CancelToken(function executor(cancel) { getUnstoredVehicles.getUnstoredVehiclesCancel = cancel })
      }
    );
  }
);
export const getVehicle = getThunkActionCreator(
  getVehicleRoutine,
  async (id) => {
    const { token: access_token } = await sessionService.loadSession();

    return await axios.post(`/user/vehicles/${id}`,
      { access_token, attributes },
      {
        cancelToken: new CancelToken(function executor(cancel) { getVehicle.getVehicleCancel = cancel })
      }
    );
  }
);
export const createVehicle = getThunkActionCreator(
  createVehicleRoutine,
  async (vehicle) => {
    const { token: access_token } = await sessionService.loadSession();

    return await axios.post(`/user/vehicles`, { access_token, vehicle, attributes });
  }
);
export const updateVehicle = getThunkActionCreator(
  updateVehicleRoutine,
  async ({ id, ...fields }) => {
    const { token: access_token } = await sessionService.loadSession();
    const response = await axios.patch(`/user/vehicles/${id}`, { access_token, vehicle: fields });

    return { response, vehicle: { id, ...fields } };
  }
);
export const storeVehicle = getThunkActionCreator(
  storeVehicleRoutine,
  async (id) => {
    const { token: access_token } = await sessionService.loadSession();
    const response = await axios.post(`/user/vehicles/${id}/store`, { access_token, attributes });

    return { response, id };
  }
);
export const takeOutVehicle = getThunkActionCreator(
  takeOutVehicleRoutine,
  async (id) => {
    const { token: access_token } = await sessionService.loadSession();
    const response = await axios.post(`/user/vehicles/${id}/take_out`, { access_token, attributes });

    return { response, id };
  }
);
export const releaseVehicle = getThunkActionCreator(
  releaseVehicleRoutine,
  async ({id, ...fields}) => {
    const { token: access_token } = await sessionService.loadSession();
    const response = await axios.post(`/user/vehicles/${id}/release`, { access_token, attributes, receiver: fields});

    return { response, receiver: { id, ...fields }};
  }
);
export const clearLocalVehicles = getThunkActionCreator(clearLocalVehiclesRoutine, async () => {});
export const clearLocalUnstoredVehicles = getThunkActionCreator(clearLocalUnstoredVehiclesRoutine, async () => {});
export const clearLocalActiveVehicle = getThunkActionCreator(clearLocalActiveVehicleRoutine, async () => {});
export const getFromVinVehicleInfo = getThunkActionCreator(getFromVinVehicleInfoRoutine, async (vin) => await axios.get(`${decodeVinUrl}/decodevinvalues/${vin}?format=json`));
export const getFromPlateVehicleInfo = getThunkActionCreator(
  getFromPlateVehicleInfoRoutine,
  async ({ plate, state }) => {
    const { token: access_token } = await sessionService.loadSession();

    return await axios.post(`/user/platetovins`, { access_token, plate, state, attributes: plateAttributes });
  }
);
export const getVehiclesStatistics = getThunkActionCreator(
  getVehiclesStatisticsRoutine,
  async () => {
    const { token: access_token } = await sessionService.loadSession();

    return await axios.get(`/user/vehicles/statistics`,
      {
        params: { access_token, attributes: statisticsAttributes },
        cancelToken: new CancelToken(function executor(cancel) { getVehiclesStatistics.getVehiclesStatisticsCancel = cancel })
      }
    );
  }
);
export const clearVehiclesStatistics = getThunkActionCreator(clearVehiclesStatisticsRoutine, async () => {});